var publicPath = __webpack_public_path__;
                    module.exports = {
                        symbol: publicPath + 'sprite.svg#app-icon',
                        view: publicPath + 'sprite.svg#view-app-icon',
                        viewBox: '0 0 32 32',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };


//////////////////
// WEBPACK FOOTER
// ./src/svg/app-icon.svg
// module id = 398
// module chunks = 0